// extracted by mini-css-extract-plugin
module.exports =  {"chars-count":"chars-count--LDqFb","charsCount":"chars-count--LDqFb","dark":"dark--XvCOk"};